// extracted by mini-css-extract-plugin
export default {"passwordBox":"PasswordPage_passwordBox__lFYCe","textPrompt":"PasswordPage_textPrompt__cL3S-","buttonBox":"PasswordPage_buttonBox__jreId"};